/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';

import { StoreType } from '@tock/shared/utils/connect';
import { dashboard } from 'types';
import { filter, includes, sortBy } from 'es-toolkit/compat';
import { getTagsForProfile } from 'utils/tagUtils';
import protos from 'utils/protos';

const { Tag } = protos;

export const configuredTagsSelector = createSelector(
  (state: StoreType) => state.tags.configuredTags,
  (configuredTags: dashboard.Tag[]): dashboard.Tag[] => configuredTags
);

export const guestTagsSelector = createSelector(configuredTagsSelector, (configuredTags) => {
  return sortBy(
    filter(configuredTags, (tag) => tag.type === Tag.TagType.GUEST),
    'ordering'
  );
});

export const visitTagsSelector = createSelector(configuredTagsSelector, (configuredTags) => {
  return sortBy(
    filter(configuredTags, (tag) => tag.type === Tag.TagType.VISIT),
    'ordering'
  );
});

export function findTagsForStrings(tagStrings: string[], tags: dashboard.Tag[]) {
  return filter(tags, (tag: dashboard.Tag) => {
    return includes(tagStrings, tag.text);
  });
}

export const mapStringToVisitTagsSelector = createCachedSelector(
  visitTagsSelector,
  (_: any, props: { visitTags: string[] }) => props.visitTags,
  (visitTags, stringTagsToProcess) => {
    return findTagsForStrings(stringTagsToProcess, visitTags);
  }
)((state: StoreType, props: { visitTags: string[] }) => props.visitTags.join('-'));

export const mapStringToGuestTagsSelector = createSelector(
  guestTagsSelector,
  (_: any, props: { guestProfile?: dashboard.GuestProfile }) =>
    getTagsForProfile(props.guestProfile),
  (guestTags, stringTagsToProcess) => {
    return findTagsForStrings(stringTagsToProcess, guestTags);
  }
);
